// extracted by mini-css-extract-plugin
export default {"segmented":"Segmented_segmented__fJVYR"};